import { Spin } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import style from './style'

const Loader = ({ relative = false, plcp = false }) => (
  <div className={classnames(style.loader, plcp && style.bg_purple, !relative && style.fullscreen)}>
    <Spin />
  </div>
)

Loader.propTypes = {
  plcp: PropTypes.bool,
  relative: PropTypes.bool
}

export default Loader
